function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg067HongKong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M280.68,194.736c-5.845,24.31-16.228,19.673-21.326,40.874   c-30.019-7.218-48.508-37.405-41.291-67.427c7.216-30.02,37.405-48.508,67.426-41.291   C275.297,169.293,285.909,172.994,280.68,194.736z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M202.782,212.749c21.314,13.07,13.695,21.515,32.282,32.914   c-16.141,26.321-50.563,34.573-76.885,18.433c-26.321-16.14-34.574-50.564-18.434-76.885   C176.92,210.008,183.717,201.059,202.782,212.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M195.841,292.403c19.017-16.232,24.693-6.377,41.277-20.531   c20.046,23.484,17.257,58.773-6.226,78.819c-23.485,20.046-58.774,17.254-78.818-6.227   C185.24,316.152,178.832,306.922,195.841,292.403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M269.453,323.618c-9.563-23.102,1.564-25.458-6.773-45.603c28.528-11.806,61.23,1.75,73.038,30.278   c11.806,28.528-1.752,61.229-30.28,73.037C288.762,341.039,278.005,344.283,269.453,323.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M321.888,263.256c-24.927,1.956-23.73-9.355-45.464-7.65c-2.414-30.779,20.585-57.692,51.367-60.109   c30.78-2.41,57.692,20.587,60.105,51.37C344.42,250.274,344.18,261.508,321.888,263.256z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg067HongKong);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };